const Joi = require("joi");
const MAX_FILE_SIZE = parseInt(process.env.REACT_APP_MAX_FILESIZE, 10);

const staffRequestSchema = (data) => {
  const schema = Joi.object({
    postType: Joi.number().valid(1, 2, 3).required().messages({
      "any.required": "Post type is required.",
      "any.only": "Post type must be one of 1, 2, or 3.",
    }),

    // `noticesTitle` validation
    noticesTitle: Joi.when("postType", {
      is: Joi.valid(1, 3),
      then: Joi.string().required().messages({
        "string.empty": "Please enter Description.",
        "any.required": "Please enter Description.",
      }),
      otherwise: Joi.optional().allow(""),
    }),

    // file: Joi.when("postType", {
    //   is: Joi.valid(2, 3),
    //   then: Joi.string().required().messages({
    //     "string.empty": "Please upload pdf document.",
    //     "any.required": "Please upload pdf document.",
    //   }),
    //   otherwise: Joi.optional().allow(""),
    // }),

    file: Joi.when("postType", {
      is: Joi.valid(2, 3),
      then: Joi.object({
        type: Joi.string().required().valid("application/pdf").messages({
          "any.required": "Please upload PDF Document.",
          "string.empty": "Please upload PDF Document.",
          "any.only": "Please select PDF Document.",
        }),
        size: Joi.number()
          .max(MAX_FILE_SIZE)
          .required()
          .messages({ "number.max": "File size should not exceed 20MB." }),
      }),
      otherwise: Joi.optional().allow(""),
    }),
  }).unknown(true);

  return schema.validate(data, {
    abortEarly: false,
  });
};

const requestFormChangeFormTypeValidation = (data) => {
  const schema = Joi.object({
    newRequestFormTypeId: Joi.number().min(1).required().messages({
      "number.min": "Please choose any Form from the list",
      "any.required": "Please choose any Form from the list",
    }),
  }).unknown(true);

  return schema.validate(data, {
    abortEarly: false,
  });
};

const publicDefenderFormSchema = (data) => {
  const schema = Joi.object({
    postType: Joi.number().valid(1, 2, 3).required().messages({
      "any.required": "Post type is required.",
      "any.only": "Post type must be one of 1, 2, or 3.",
    }),

    // `noticesTitle` validation
    pdFormPostBody: Joi.when("postType", {
      is: Joi.valid(1, 3),
      then: Joi.string().required().messages({
        "string.empty": "Please enter Description.",
        "any.required": "Please enter Description.",
      }),
      otherwise: Joi.optional().allow(""),
    }),

    // file: Joi.when("postType", {
    //   is: Joi.valid(2, 3),
    //   then: Joi.string().required().messages({
    //     "string.empty": "Please upload pdf document.",
    //     "any.required": "Please upload pdf document.",
    //   }),
    //   otherwise: Joi.optional().allow(""),
    // }),

    file: Joi.when("postType", {
      is: Joi.valid(2, 3),
      then: Joi.object({
        type: Joi.string().required().valid("application/pdf").messages({
          "any.required": "Please upload PDF Document.",
          "string.empty": "Please upload PDF Document.",
          "any.only": "Please select PDF Document.",
        }),
        size: Joi.number()
          .max(MAX_FILE_SIZE)
          .required()
          .messages({ "number.max": "File size should not exceed 20MB." }),
      }),
      otherwise: Joi.optional().allow(""),
    }),
  }).unknown(true);

  return schema.validate(data, {
    abortEarly: false,
  });
};

const publicDefenderRequestFormSchema = (data) => {
  const schema = Joi.object({
    postType: Joi.number().valid(1, 2, 3).required().messages({
      "any.required": "Post type is required.",
      "any.only": "Post type must be one of 1, 2, or 3.",
    }),

    // `noticesTitle` validation
    pdFormPostBody: Joi.when("postType", {
      is: Joi.valid(1, 3),
      then: Joi.string().required().messages({
        "string.empty": "Please enter Description.",
        "any.required": "Please enter Description.",
      }),
      otherwise: Joi.optional().allow(""),
    }),

    // file: Joi.when("postType", {
    //   is: Joi.valid(2, 3),
    //   then: Joi.string().required().messages({
    //     "string.empty": "Please upload pdf document.",
    //     "any.required": "Please upload pdf document.",
    //   }),
    //   otherwise: Joi.optional().allow(""),
    // }),
    file: Joi.when("postType", {
      is: Joi.valid(2, 3),
      then: Joi.object({
        type: Joi.string().required().valid("application/pdf").messages({
          "any.required": "Please upload PDF Document.",
          "string.empty": "Please upload PDF Document.",
          "any.only": "Please select PDF Document.",
        }),
        size: Joi.number()
          .max(MAX_FILE_SIZE)
          .required()
          .messages({ "number.max": "File size should not exceed 20MB." }),
      }),
      otherwise: Joi.optional().allow(""),
    }),
  }).unknown(true);

  return schema.validate(data, {
    abortEarly: false,
  });
};

const messageToInmateRequestFormSchema = (data) => {
  const schema = Joi.object({
    postType: Joi.number().valid(1, 2, 3).required().messages({
      "any.required": "Post type is required.",
      "any.only": "Post type must be one of 1, 2, or 3.",
    }),

    // `pdFormPostBody` validation
    pdFormPostBody: Joi.when("postType", {
      is: Joi.valid(1, 3),
      then: Joi.string().required().messages({
        "string.empty": "Please enter Description.",
        "any.required": "Please enter Description.",
      }),
      otherwise: Joi.optional().allow(""),
    }),

    // file: Joi.when("postType", {
    //   is: Joi.valid(2, 3),
    //   then: Joi.string().required().messages({
    //     "string.empty": "Please upload pdf document.",
    //     "any.required": "Please upload pdf document.",
    //   }),
    //   otherwise: Joi.optional().allow(""),
    // }),
    file: Joi.when("postType", {
      is: Joi.valid(2, 3),
      then: Joi.object({
        type: Joi.string().required().valid("application/pdf").messages({
          "any.required": "Please upload PDF Document.",
          "string.empty": "Please upload PDF Document.",
          "any.only": "Please select PDF Document.",
        }),
        size: Joi.number()
          .max(MAX_FILE_SIZE)
          .required()
          .messages({ "number.max": "File size should not exceed 20MB." }),
      }),
      otherwise: Joi.optional().allow(""),
    }),
  }).unknown(true);

  return schema.validate(data, {
    abortEarly: false,
  });
};

const createRequestschema = (data, isAbortEarly = false) => {
  const schema = Joi.object({
    requestFormTypeID: Joi.number().min(1).required().messages({
      "number.base": "Please select Message Type.",
      "number.min": "Please select Message Type.",
      "any.required": "Please select Message Type.",
    }),

    typ_RequestForumThreadMGUserInsert: Joi.array()
      .min(1)
      .items(
        Joi.object({
          inmateID: Joi.number().required().messages({
            "any.required": "Select inmate.",
          }),
        })
      )
      .min(1)
      .messages({
        "array.min": "Select inmate.",
      }),

    postType: Joi.number().valid(1, 2, 3).required().messages({
      "any.required": "Post type is required.",
      "any.only": "Post type must be one of text or pdf.",
    }),

    formPostBody: Joi.when("postType", {
      is: Joi.valid(1, 3),
      then: Joi.string().required().messages({
        "string.empty": "Please enter Description.",
        "any.required": "Please enter Description.",
      }),
      otherwise: Joi.optional().allow(""),
    }),

    file: Joi.when("postType", {
      is: Joi.valid(2, 3),
      then: Joi.string().required().messages({
        "string.empty": "Please upload PDF Document.",
        "any.required": "Please upload PDF Document.",
      }),
      otherwise: Joi.optional().allow(""),
    }),

    closeStatus: Joi.number().valid(0, 1).messages({
      "any.only": "Post type must be one of 1, 2, or 3.",
    }),
  }).unknown(true);

  return schema.validate(data, {
    abortEarly: isAbortEarly,
  });
};

const createStaffRequestFormSchema = (data, isAbortEarly = false) => {
  const schema = Joi.object({
    requestFormTypeID: Joi.number().min(1).required().messages({
      "number.base": "Please select Message Type.",
      "number.min": "Please select Message Type.",
      "any.required": "Please select Message Type.",
    }),

    typ_RequestForumThreadMGUserInsert: Joi.array()
      .min(1)
      .items(
        Joi.object({
          inmateID: Joi.number().required().messages({
            "any.required": "Please select Inmate.",
          }),
        })
      )
      .min(1)
      .messages({
        "array.min": "Please select Inmate.",
      }),

    postType: Joi.number().valid(1, 2, 3).required().messages({
      "any.required": "Post type is required.",
      "any.only": "Post type must be one of text or pdf.",
    }),

    // file: Joi.when("postType", {
    //   is: Joi.valid(1, 3),
    //   then: Joi.string().required().messages({
    //     "string.empty": "Please enter Description.",
    //     "any.required": "Please enter Description.",
    //   }),
    //   otherwise: Joi.optional().allow(""),
    // }),

    // pdfAttachPath: Joi.when("postType", {
    //   is: Joi.valid(2, 3),
    //   then: Joi.string().required().messages({
    //     "string.empty": "Please upload pdf document",
    //     "any.required": "Please upload pdf document",
    //   }),
    //   otherwise: Joi.optional().allow(""),
    // }),

    formPostBody: Joi.when("postType", {
      is: Joi.valid(1, 3),
      then: Joi.string().required().messages({
        "string.empty": "Please enter Description.",
        "any.required": "Please enter Description.",
      }),
      otherwise: Joi.optional().allow(""),
    }),

    file: Joi.when("postType", {
      is: Joi.valid(2, 3),
      then: Joi.object({
        type: Joi.string().required().valid("application/pdf").messages({
          "any.required": "Please upload PDF Document.",
          "string.empty": "Please upload PDF Document.",
          "any.only": "Please select PDF Document.",
        }),
        size: Joi.number()
          .max(MAX_FILE_SIZE)
          .required()
          .messages({ "number.max": "File size should not exceed 20MB." }),
      }),
      otherwise: Joi.optional().allow(""),
    }),
    closeStatus: Joi.number().valid(0, 1).messages({
      "any.only": "Post type must be one of 1, 2, or 3.",
    }),
  }).unknown(true);

  return schema.validate(data, {
    abortEarly: isAbortEarly,
  });
};

const validateField = (fieldName, value) => {
  if (!createRequestschema.describe().keys[fieldName]) return null; // Ignore unknown fields
  return createRequestschema.extract(fieldName).validate(value);
};

const feedbackSchema = (data) => {
  const schema = Joi.object({
    feedback: Joi.array()
      .min(1)
      .items(
        Joi.object({
          notesRemarks: Joi.string().required().messages({
            "any.required": "Please enter Notes.",
            "string.empty": "Please enter Notes.",
          }),

          notesSNo: Joi.number().required().messages({
            "any.required": "Please select item",
          }),
        }).unknown(true)
      )
      .min(1)
      .messages({
        "array.min": "Please select atleast one inmate.",
      }),
  }).unknown(true);

  return schema.validate(data, {
    abortEarly: false,
  });
};

const publicDefenderSchema = (data) => {
  const schema = Joi.object({
    publicDefenderUserId: Joi.number().min(1).required().messages({
      "number.base": "Please choose Public Defender from the list.",
      "number.min": "Please choose Public Defender from the list.",
      "any.required": "Please choose Public Defender from the list.",
    }),
  }).unknown(true);

  return schema.validate(data, {
    abortEarly: true,
  });
};

const publicDefenderReject = (data) => {
  const schema = Joi.object({
    PDRequestRejectReason: Joi.string().required().messages({
      "any.required": "Please enter Reject Reason.",
      "string.empty": "Please enter Reject Reason.",
    }),
  }).unknown(true);

  return schema.validate(data, {
    abortEarly: true,
  });
};

module.exports = {
  staffRequestSchema,
  publicDefenderFormSchema,
  createRequestschema,
  createStaffRequestFormSchema,
  feedbackSchema,
  publicDefenderSchema,
  messageToInmateRequestFormSchema,
  publicDefenderRequestFormSchema,
  publicDefenderReject,
  validateField,
  requestFormChangeFormTypeValidation,
};
